import type { Components, Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

const MuiMenuItem: Components<Theme>['MuiMenuItem'] = {
  // ▼▼▼▼▼▼▼▼ 🎨 STYLE ▼▼▼▼▼▼▼▼
  styleOverrides: {
    root: ({ theme }) => ({
      ...theme.mixins.menuItemStyles(theme)
    })
  }
};

// ----------------------------------------------------------------------

const MuiListSubheader: Components<Theme>['MuiListSubheader'] = {
  // ▼▼▼▼▼▼▼▼ 🎨 STYLE ▼▼▼▼▼▼▼▼
  styleOverrides: {
    root: {
      backgroundColor: 'transparent'
    }
  }
};

/* **********************************************************************
 * 🚀 Export
 * **********************************************************************/
export const menu: Components<Theme> = {
  MuiMenuItem,
  MuiListSubheader
};
